// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__1GBKk","title":"ClientCherryInfo_title__3edV6","itemText":"ClientCherryInfo_itemText__3mhZ1"};